import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Typography,
  IconButton,
  Chip,
  CircularProgress,
  Skeleton,
} from '@mui/material';
import {
  Description as DescriptionIcon,
  Visibility as VisibilityIcon,
  Download as DownloadIcon,
} from '@mui/icons-material';
import { formatFileName, formatFileType } from '../utils';

const AttachmentsDialog = ({
  open,
  attachments,
  attachmentsLoading,
  downloadingIndex,
  onClose,
  onDownload,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Attachments {attachmentsLoading && <CircularProgress size={20} sx={{ ml: 1 }} />}
      </DialogTitle>
      <DialogContent dividers>
        {attachmentsLoading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {[...Array(3)].map((_, i) => <Skeleton key={i} height={60} />)}
          </Box>
        ) : attachments.length === 0 ? (
          <Typography align="center" sx={{ py: 3 }} color="text.secondary">
            No attachments found
          </Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>Name</strong></TableCell>
                  <TableCell><strong>Type</strong></TableCell>
                  <TableCell align="center"><strong>Actions</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {attachments.map((file, idx) => {
                  const fileName = formatFileName(file, idx);
                  const filePath = file.path;
                  const fileType = formatFileType(file, filePath);
                  const isDownloading = downloadingIndex === idx;

                  return (
                    <TableRow key={idx} hover>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <DescriptionIcon fontSize="small" color="action" />
                          <Typography variant="body2" noWrap>{fileName}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell><Chip label={fileType} size="small" /></TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                          {/* VIEW (direct path) */}
                          {filePath && (
                            <IconButton
                              size="small"
                              component="a"
                              href={filePath}
                              target="_blank"
                              rel="noopener noreferrer"
                              title="View"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          )}

                          {/* DOWNLOAD (via POST API) */}
                          {filePath && (
                            isDownloading ? (
                              <CircularProgress size={16} />
                            ) : (
                              <IconButton
                                size="small"
                                onClick={() => onDownload(file, idx)}
                                title="Download"
                              >
                                <DownloadIcon fontSize="small" />
                              </IconButton>
                            )
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AttachmentsDialog;